import Image from "next/image";
import ctaBackground from "@/assets/images/CTA-backgroung.jpg";

interface BannerSectionProps {
  title?: string;
}

export const BannerSection = ({ title }: BannerSectionProps) => {
  return (
    <div
      className="flex h-[35vh] w-full items-end justify-start overflow-x-hidden px-4 pb-8 ph:px-24 ph:pb-16 md:px-48 lg:px-72 xl:px-96 relative"
      style={{
        backgroundImage: `url(${ctaBackground.src})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Overlay with slight opacity */}
      <div className="absolute inset-0 bg-black opacity-25"></div>
      <p className="text-3xl leading-[48px] text-white ph:text-5xl ph:leading-[60px] md:leading-[72px] lg:text-5xl lg:leading-[84px] relative z-10">
        {title}
      </p>
    </div>
  );
};
